// extracted by mini-css-extract-plugin
module.exports = {"header":"index-module_header_1tvw1","content":"index-module_content_15GRC","title":"index-module_title_yHH6H","desc":"index-module_desc_2joC2","tip":"index-module_tip_oX1hy"};